/**
 * Fetches the effective performance profile once per session and applies
 * its `animations_enabled` setting globally (via a body class), so
 * every page automatically respects LOW/MEDIUM/HIGH mode without each
 * component needing its own check.
 */

import { useEffect, useState } from "react";
import { apiClient } from "@/api/client";
import type { PerformanceProfile } from "@/types";

export function usePerformanceMode(): PerformanceProfile | null {
  const [profile, setProfile] = useState<PerformanceProfile | null>(null);

  useEffect(() => {
    let cancelled = false;
    apiClient
      .get<PerformanceProfile>("/system/performance")
      .then(({ data }) => {
        if (cancelled) return;
        setProfile(data);
        document.documentElement.classList.toggle("no-animations", !data.animations_enabled);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  return profile;
}
